export const MODEL_DESIGNER = {
    id: null,
    domain: null,
    headerLogo: null,
    footerLogo: null,
    homeBanner: null,
    settings: {
      primaryColor: null,
      btnBackground: null,
      btnColor: null,
      background: null,
      publicName: null,
      website: null,
      twitter: null,
      facebook: null,
      contactPhone: null,
      headerLogo: null,
      footerLogo: null,
      homeBanner: null,
    },
  }